import styles from "./_table-styles.module.scss";

const ListItem = ({ broker }) => {
  return (
    <div
      id={"item" + broker.id}
      className={styles.table_row}
      role="row"
      tabIndex={0}
    >
      <span role="cell">{broker.businessId}</span>
      <span role="cell">{broker.brokeringForm}</span>
      <span role="cell">{broker.avi}</span>
    </div>
  );
};

export default ListItem;
